const MoneyMask = (value: string) => {
  value = value.replace(".", "").replace(",", "").replace(/\D/g, "");

  const options = { minimumFractionDigits: 2 };
  const result = new Intl.NumberFormat("es-CO", options).format(
    parseFloat(value)
  );

  return result;
};

const EmailMask = (myemailId: string) => {
  var maskid = "";
  var prefix = myemailId.substring(0, myemailId.lastIndexOf("@"));
  var postfix = myemailId.substring(myemailId.lastIndexOf("@"));

  for (var i = 0; i < prefix.length; i++) {
    if (i === 0 || i === prefix.length - 1) {
      ////////
      maskid = maskid + prefix[i].toString();
    } else {
      maskid = maskid + "*";
    }
  }
  maskid = maskid + postfix;

  return maskid;
};

const numberMask = (number: string) => {
  if (number.length < 10) {
    return number.replace(/^\d{1,3}/, (m) => m.replace(/\d/g, "*"));
  } else {
    return number.replace(/^\d{1,5}/, (m) => m.replace(/\d/g, "*"));
  }
};

export { MoneyMask, EmailMask, numberMask };
